import React from 'react';
import styles from './styles.module.scss';
import Text from '@profile/src/Components/Text';
import classNames from 'classnames';
import icCopy from 'assets/svg/ic_copy.svg';
import { TooltipDirection } from '@profile/src/Components/TooltipProvider/Tooltip';
import { useTooltip } from '@profile/src/Components/TooltipProvider';
import { ellipsisMiddleCustom } from '@profile/src/utils/text';
import { webImageUri } from '@profile/src/utils/uri';
import { formatCurrency } from '@wolffun/system-currency';
import { formatDateTimeByTimestamp } from '@profile/src/utils/date';
import { formatType, parseCosmeticType } from '../../../utils';
import { copyToClipboard } from '@profile/src/utils/copyToClipboard';

const HeroItem = ({
  className,
  item
}) => {
  var _item$tradeInfo, _item$tradeInfo2, _item$tradeInfo5;

  const tooltip = useTooltip();
  const copyRef = React.useRef(null);
  const statusMap = 'Completed';

  const onPress = position => {
    tooltip.show('Copied', position, TooltipDirection.BOTTOM, {
      backgroundColor: '#261858',
      textColor: '#fff',
      delay: 1500
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.item, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapBox
  }, !!item.urlImage && /*#__PURE__*/React.createElement("img", {
    className: styles.boxImg,
    src: webImageUri(item.urlImage)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.heroInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapName
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    className: styles.name
  }, item.name ? `${item.name} - ` : '', parseCosmeticType(item.type))), /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    className: styles.tokenId
  }, "#", item.itemId))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapValue, styles.wrapType)
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    className: styles.type
  }, formatType(item.source)), /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    className: classNames(styles.status, styles.completed)
  }, statusMap)), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValue
  }, !!item.tradeInfo && /*#__PURE__*/React.createElement(Text, {
    className: styles.value
  }, formatCurrency((_item$tradeInfo = item.tradeInfo) === null || _item$tradeInfo === void 0 ? void 0 : _item$tradeInfo.price, {
    withCurrency: true,
    trimWholeFraction: true
  })), !!item.timestamp && /*#__PURE__*/React.createElement(Text, {
    className: styles.subValue
  }, formatDateTimeByTimestamp(item.timestamp))), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapAddress
  }, !!((_item$tradeInfo2 = item.tradeInfo) !== null && _item$tradeInfo2 !== void 0 && _item$tradeInfo2.address) && /*#__PURE__*/React.createElement("div", {
    ref: copyRef,
    onClick: () => {
      var _item$tradeInfo3, _item$tradeInfo4;

      ((_item$tradeInfo3 = item.tradeInfo) === null || _item$tradeInfo3 === void 0 ? void 0 : _item$tradeInfo3.address) && copyToClipboard((_item$tradeInfo4 = item.tradeInfo) === null || _item$tradeInfo4 === void 0 ? void 0 : _item$tradeInfo4.address);

      if (copyRef.current) {
        const rect = copyRef.current.getBoundingClientRect();
        onPress({
          top: rect.top + document.documentElement.scrollTop + 30,
          left: rect.left + document.documentElement.scrollLeft + rect.width / 2
        });
      }
    },
    className: styles.addressId
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.code
  }, ellipsisMiddleCustom((_item$tradeInfo5 = item.tradeInfo) === null || _item$tradeInfo5 === void 0 ? void 0 : _item$tradeInfo5.address)), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icCopy
  }))));
};

export default HeroItem;